/* src/app/core/modules/shared/components/quotation-preview/quotation-preview.component.scss */
/*# sourceMappingURL=/avvera/dev/quotation-preview.component.css.map */
